<template>
    <el-drawer 
        title="添加白名单用户" 
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
        append-to-body
    >
        <div class="drawer-content">
            <el-form :model="formData"  ref="formData">                
				<el-form-item  prop="userId" label="白名单用户:" :rules="[{required: true, message: '请选择用户'}]">					
					<el-select
					    v-model="formData.userId" 
					    filterable 
					    remote
					    placeholder="请选择用户"
					    :remote-method="searchUser"
					    :loading="userLoading"
					    size="medium">
					    <el-option
					        v-for="item in userList"
					        :key="item.id"
					        :label="item.name + '/' + item.id"
					        :value="item.id">
					    </el-option>
					</el-select>
				</el-form-item>                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import {fetchUser} from '@/assets/js/commonApi';
export default {
    props:{
        id:{
            type:[Number,String],
            default:1
        }
    },
    data(){       
      return {
		userLoading:false,
		submitLoading: false,		
        drawerShow:false,
		formData:{
			userId: '',
            goodsId: '',
            skuId: ''
		},
		userList:[]
      }  
    },
    methods: {
		show( goodsId, skuId) {
            this.formData.goodsId = goodsId;
            this.formData.skuId = skuId;
			this.drawerShow = true;
		},
		close(){		
            this.formData.userId = '';    
			this.drawerShow = false;
		},
		// 搜索用户
		async searchUser(query){
			if(query !== ""){
				this.userLoading = true;
				const res = await fetchUser({
					queryValue:query,
					// userType:userType,
				}).finally(() => {
					this.userLoading = false;
				});
				
				const { state, result } = res.data;
				
				if (state == 1 && result) {
					this.userList = result;
				}
			}
		},
        submitForm(){
			//return
            this.$refs['formData'].validate((valid) => {
                if(valid){
                    this.submitLoading = true;
                    this.$request({
                        url: '/activityTicketWhite/add',
                        method: "POST",
                        params:{
                            ...this.formData
                        }
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('操作成功');                            
                            this.$emit("onUpdate");
							this.close()
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            })            
        },
        
    }
}
</script>